import { useContext, useMemo, useState } from 'react';
import moment from 'moment';
import { createPortal } from 'react-dom';
import { CreateAccountManuallyStepsContext } from '../../CreateAccountManuallySteps.context';
import { useSignaturePaymentProspect } from '../../../../../../../../../hooks/fetchers/useSignaturePaymentProspect/useSignaturePaymentProspect';
import { useIsDev } from '../../../../../../../../../hooks/useIsDev/useIsDev';
import Loading from '../../../../../../../../commons/Loading/Loading';

export default () => {

  const IS_DEV = useIsDev()

  const { prospectId: id, accountInfos, signatureInfos } = useContext(CreateAccountManuallyStepsContext)

  if (!accountInfos || !signatureInfos) return <></>

  const {
    plan,
    email,
    phone,
    firstName,
    lastName,
  } = accountInfos;

  const {
    amount,
    fieldsOfActivity,
    duration,
    code
  } = signatureInfos

  const currentTime = useMemo(() => moment().utc().format('YYYYMMDDHHmmss'), []);

  const { data, isLoading } = useSignaturePaymentProspect({
    id,
    id_plan: parseInt(plan),
    email,
    phone: phone || '',
    firstName: firstName || '',
    lastName: lastName || '',
    currentTime,
    fieldsOfActivity,
    duration,
    code
  });

  const [contentRef, setContentRef] = useState<HTMLIFrameElement | null>(null);

  const mountNode = useMemo(() => contentRef?.contentWindow?.document?.body, [contentRef]);

  if (isLoading || !data) return <p>Chargement...</p>;

  return (
    <iframe
      id="nameFrame"
      name="nameFrame"
      className="register_payment-iframe"
      height={540}
      ref={setContentRef}>
      {mountNode ?
        createPortal(
          <form
            method="POST"
            action="https://sogecommerce.societegenerale.eu/vads-payment/"
            target="nameFrame">
            <input type="hidden" name="vads_action_mode" value="IFRAME" />
            <input type="hidden" name="vads_amount" value={(amount * 100).toFixed(0)} />
            <input type="hidden" name="vads_ctx_mode" value={IS_DEV ? 'TEST' : 'PRODUCTION'} />
            <input type="hidden" name="vads_currency" value="978" />
            <input type="hidden" name="vads_cust_cell_phone" value={phone} />
            <input type="hidden" name="vads_cust_email" value={email} />
            <input type="hidden" name="vads_cust_first_name" value={firstName} />
            <input type="hidden" name="vads_cust_id" value={`ENT${id}`} />
            <input type="hidden" name="vads_cust_last_name" value={lastName} />
            <input type="hidden" name="vads_language" value="fr" />
            <input type="hidden" name="vads_page_action" value="PAYMENT" />
            <input type="hidden" name="vads_payment_config" value="SINGLE" />
            <input type="hidden" name="vads_site_id" value="51177819" />
            <input type="hidden" name="vads_trans_date" value={currentTime} />
            <input type="hidden" name="vads_trans_id" value={data?.transId} />
            <input type="hidden" name="vads_redirect_error_timeout" value="2" />
            <input type="hidden" name="vads_redirect_success_timeout" value="0" />
            <input type="hidden" name="vads_order_info" value="PROSPECT" />
            <input type="hidden" name="vads_url_return" value="http://localhost:5000/payment/retour/get" />
            <input
              type="hidden"
              name="vads_url_success"
              // value={`${IS_DEV ? 'http://localhost:5000' : 'https://www.publiconsult.fr'}/payment/retour/post`}
              value={IS_DEV ? 'http://localhost:5000/payment/ENT/success' : 'https://www.publiconsult.fr/payment/retour/post'}
            />
            <input
              type="hidden"
              name="vads_url_error"
              value={`${IS_DEV ? 'http://localhost:3000' : 'https://www.publiconsult.fr'}/step_wizard/ENT`}
            />
            <input type="hidden" name="vads_return_mode" value={IS_DEV ? 'GET' : 'POST'} />
            <input type="hidden" name="vads_version" value="V2" />
            <input
              type="hidden"
              name="vads_theme_config"
              value="FORM_TARGET=_top;3DS_LOGOS=true;SIMPLIFIED_DISPLAY=true"
            />
            <input type="hidden" name="signature" value={data?.signature} />
            {/* <div
                style={{
                  overflowY: 'scroll',
                  overflowX: 'hidden',
                  height: 350,
                  marginBottom: 16,
                }}>
                <p style={{ fontFamily: 'sans-serif', fontSize: 13 }}>
                  <strong>CGV Publiconsult</strong> <br />
                  <br />
                  Identité du vendeur :<br />
                  SAS LENS GROUP- inscrite au RCS de Perpignan 847 550 910 – N° SIRET 84755091000024
                  – N° de TVA FR84847550910
                  <br />
                  Clause n° 1 : Objet et champ d'application
                  <br />
                  Les présentes conditions générales de vente (CGV) constituent le socle de la
                  négociation commerciale et sont systématiquement adressées ou remises à chaque
                  acheteur pour lui permettre de passer commande. Les conditions générales de vente
                  décrites ci-après détaillent les droits et obligations de Lens Group et de son
                  client dans le cadre de la vente du service suivant : Publiconsult.
                  <br />
                  Toute acceptation du devis/bon de commande en ce compris la clause « Je reconnais
                  avoir pris connaissance et j'accepte les conditions générales de vente ci-annexées
                  » implique l'adhésion sans réserve de l'acheteur aux présentes conditions
                  générales de vente.
                  <br />
                  Clause n°2 Prix :<br />
                  Les prix du service vendu sont ceux en vigueur au jour de la prise de commande.
                  Ils sont libellés en euros et calculés hors taxes. Par voie de conséquence, ils
                  seront majorés du taux de TVA applicable au jour de la commande.
                  <br />
                  Lens Group s'accorde le droit de modifier ses tarifs à tout moment. Toutefois,
                  elle s'engage à facturer les services commandés aux prix indiqués lors de
                  l'enregistrement de la commande.
                  <br />
                  Les acheteurs publics peuvent souscrire à une option payante lors de leur dépôt de
                  consultation.
                  <br />
                  Clause n°3 Précommandes et pré-inscription
                  <br />
                  Sur la partie s’étalant du 17/07/2023 au 01/09/2023, seulement des précommandes
                  avec paiement immédiat seront possibles.
                  <br />
                  Sur la partie s’étalant du 17/07/2023 au 01/09/2023, les acheteurs publics
                  pourront s’inscrivent sur Publiconsult mais ne pourront pas réaliser de demande de
                  consultation.
                  <br />
                  Clause n° 4 Conditions de règlements et pénalités de retard
                  <br />
                  Le règlement de l’abonnement annuel de Publiconsult est effectué en ligne sur un
                  site protégé (https://) par carte bancaire ou par Paypal.
                  <br />
                  Lorsqu’un acheteur public à souscrit à une option payante, le paiement de cette
                  option se fera sous 30 jours calendaire après le dépôt de la facture correspondant
                  à cette option sur la plateforme Chorus.
                  <br />
                  Tout retard de paiement fera l’objet de pénalités. La pénalité de retard sera
                  basée sur le taux d'intérêt taux directeur de la Banque centrale européenne (BCE),
                  en vigueur au 1er janvier ou au 1er juillet, majoré de 10 points. Cette pénalité
                  est calculée sur le montant TTC de la somme restant due, et court à compter de la
                  date d'échéance du prix sans qu'aucune mise en demeure préalable ne soit
                  nécessaire.
                  <br />
                  En sus des indemnités de retard, toute somme, y compris l’acompte, non payée à sa
                  date d’exigibilité produira de plein droit le paiement d’une indemnité forfaitaire
                  de 40 euros due au titre des frais de recouvrement (Articles 441-10 et D. 441-5 du
                  code de commerce).
                  <br />
                  Clause n°5 : Exécution des services :<br />
                  Suite à son inscription en ligne et son paiement, le Client reçoit un mail
                  d’activation de sa demande.
                  <br />
                  Son apparition dans l’annuaire en tant qu’entreprise est réalisée sous 48h
                  maximum.
                  <br />
                  La réception d’offres de la part des acheteurs public sera active sous 48h
                  maximum.
                  <br />
                  L’offre Publiconsult est activée pour une durée de 365 jour calendaire à compter
                  du paiement de la commande. Passé ce délai, le Client devra procéder à une
                  nouvelle commande pour réactiver son offre. Le Client n’est pas réengagé
                  automatiquement.
                  <br />
                  Clause n°6 Garantie et SAV :<br />
                  Assurances :<br />
                  • Nom du professionnel qui garantit les biens
                  <br />
                  • Coordonnées postales et téléphoniques, adresse électronique du professionnel ou
                  tout autre moyen de communication permettant de demander la mise en place des
                  garanties
                  <br />
                  Pour toute demande sur l’utilisation du service, le Client contacte directement
                  par email contact@publiconsult.fr
                  <br />
                  Clause n°7 : Suppression du service
                  <br />
                  Le service pourra être supprimé à tout moment, sans préavis et sans remboursement
                  possible dans les cas suivants :<br />
                  - Passage de l’entreprise du Client en liquidation judiciaire ou fermeture de la
                  société
                  <br />
                  - Non-respect de la catégorie sélectionnée en fonction du nombre de salariés dans
                  l’entreprise au moment de l’inscription
                  <br />
                  Clause n°8 Remboursement et délai de rétractation :<br />
                  Le délai de rétractation court à partir de 14 jours calendaires à compter du
                  paiement de la vente Publiconsult.
                  <br />
                  Modalités de Remboursement :<br />
                  Tout client souhaitant se rétracter après avoir conclus et payé la vente de
                  Publiconsult doit rédiger le formulaire type de rétractation et l’envoyer par voie
                  postale au siège de Lens Group ou par email à l’adresse mail suivante
                  contact@publiconsult.fr:
                  <br />
                  Je soussigné (e), Madame /Monsieur Nom Prénom………………………………………………………………….,
                  représentant de la société Nom de la Société…………………………………………………………………………… demande
                  à me rétracter suite à la vente de votre produit Publiconsult.
                  <br />
                  Cette vente a eu lieu le DATE (JJ/MM/AAAA)………………………………………………………………………….
                  <br />
                  Merci de bien vouloir procéder au remboursement du montant TTC suivant :
                  …………………..€
                  <br />
                  Sur le compte bancaire suivant :<br />
                  Nom du compte bancaire :<br />
                  IBAN …………………
                  <br />
                  BIC …………….
                  <br />
                  Afin d’améliorer la rapidité du traitement de ma demande de remboursement,
                  j’autorise Lens Group à me contacter par téléphone XX.XX.XX.XX. XX ou par email
                  ……………………………………….@................
                  <br />
                  <br />
                  Lens Group procède sous 14 jours au remboursement de la totalité des sommes
                  versées par le Client après avoir pris notification de la demande.
                  <br />
                  Clause n° 9 : Force majeure
                  <br />
                  La responsabilité de Lens Group ne pourra pas être mise en œuvre si la
                  non-exécution ou le retard dans l'exécution de l'une de ses obligations décrites
                  dans les présentes conditions générales de vente découle d'un cas de force
                  majeure. À ce titre, la force majeure s'entend de tout événement extérieur,
                  imprévisible et irrésistible au sens de l'article 1148 du Code civil.
                  <br />
                  Clause n° 10 : Litiges
                  <br />
                  Le Client a la possibilité de faire appel à un médiateur de la consommation.
                  <br />
                  Tout litige relatif à l'interprétation et à l'exécution des présentes conditions
                  générales de vente est soumis au droit français.
                  <br />À défaut de résolution amiable, le litige sera porté devant le Tribunal de
                  commerce de Perpignan.
                </p>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  columnGap: 8,
                }}>
                <input type="checkbox" onChange={(e) => setChecked(e.target.checked)} />
                <span style={{ fontFamily: 'sans-serif', fontSize: 13 }}>
                  Je reconnais avoir pris connaissance et j’accepte les{' '}
                  <a target="_blank" href="">
                    conditions générales de vente
                  </a>
                  .
                </span>
              </div> */}
            <button
              type="submit"
              style={{
                width: '100%',
                border: 'none',
                padding: 16,
                margin: '16px 0',
                borderRadius: 14,
                fontSize: 18,
                color: 'white',
                textTransform: 'uppercase',
                backgroundImage: 'linear-gradient(to right, #206C87, #214764)',
                cursor: 'pointer',
              }}>
              Paiement par carte bancaire
            </button>
          </form>,
          mountNode
        ) : <Loading />}
    </iframe>
  );
};
